import { Shield, FileText, Headphones, ChartLine, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const Features = () => {
  return (
    <section className="py-4 sm:py-8 sm:my-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 sm:mb-12 text-center">
          <Badge variant="secondary" className="bg-[#F8F7FF] text-primary text-sm mb-2 flex items-center gap-1 mx-auto w-fit">
            <Star className="h-4 w-4" />
            Features
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold mt-2 px-2 leading-relaxed">
            Manage your insurance
            <span className="block text-primary">with Kover King</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
          {/* Left Column - 4 Cards with purple background */}
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 bg-[#F8F7FF] p-4 sm:p-6 rounded-xl">
            {[
              {
                icon: <Shield className="w-8 h-8 text-primary" />,
                title: "Comprehensive Coverage",
                description: "Get complete protection for all your insurance needs under one roof.",
                features: [
                  "Multi-policy discounts",
                  "Customizable plans",
                  "24/7 claim support"
                ]
              },
              {
                icon: <FileText className="w-8 h-8 text-primary" />,
                title: "Easy Claims Process",
                description: "File and track your claims with our streamlined digital platform.",
                features: [
                  "Online claim filing",
                  "Real-time status updates",
                  "Fast processing"
                ]
              },
              {
                icon: <Headphones className="w-8 h-8 text-primary" />,
                title: "24/7 Support",
                description: "Our dedicated support team is always available to assist you.",
                features: [
                  "Phone, email, and chat support",
                  "Expert advice",
                  "Emergency assistance"
                ]
              },
              {
                icon: <ChartLine className="w-8 h-8 text-primary" />,
                title: "Policy Analytics",
                description: "Track your coverage and premiums with detailed insights.",
                features: [
                  "Visual dashboards",
                  "Premium breakdowns",
                  "Coverage comparisons"
                ]
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-lg">
                <div className="p-2 sm:p-3 bg-[#F8F7FF] w-fit rounded-lg mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-lg sm:text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm sm:text-base mb-4">{feature.description}</p>
                <ul className="space-y-2">
                  {feature.features.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-gray-600 text-sm sm:text-base">
                      <svg className="w-4 h-4 text-primary flex-shrink-0" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                        />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Right Column - Insurance Card */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg p-4 sm:p-8">
              <div className="flex items-center justify-between mb-4">
                <div className="flex space-x-2">
                  <button className="bg-gray-100 px-3 sm:px-4 py-2 rounded-md text-sm font-medium">Monthly</button>
                  <button className="bg-gray-100 px-3 sm:px-4 py-2 rounded-md text-sm font-medium">Yearly</button>
                </div>
              </div>
              
              <div className="space-y-3 sm:space-y-4">
                {[
                  {
                    icon: <Shield className="w-8 h-8 text-primary" />,
                    title: "Auto Insurance",
                    status: "Premium Due",
                    price: "$128.00"
                  },
                  {
                    icon: <FileText className="w-8 h-8 text-primary" />,
                    title: "Home Insurance",
                    status: "Active Policy",
                    price: "$245.00"
                  },
                  {
                    icon: <ChartLine className="w-8 h-8 text-primary" />,
                    title: "Business Insurance",
                    status: "Active Policy",
                    price: "$350.00"
                  },
                  {
                    icon: <Shield className="w-8 h-8 text-primary" />,
                    title: "Life Insurance",
                    status: "Active Policy",
                    price: "$180.00"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg">
                    <div className="flex items-center gap-3 sm:gap-4">
                      <div className="p-2 bg-white rounded-lg">
                        {item.icon}
                      </div>
                      <div>
                        <h3 className="font-medium text-sm sm:text-base">{item.title}</h3>
                        <p className="text-sm text-gray-500">{item.status}</p>
                      </div>
                    </div>
                    <span className="text-primary font-medium text-sm sm:text-base">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
